export const form = {
  formCopyLink: 'Скопировать ссылку',
  formLinkCopied: 'Ссылка скопирована!'
}
